import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LoanService } from '../loan.service';

@Component({
    selector: 'app-loan-error',
    template: `
        <div class="loan__error state state--info grid-spacing-normal no-margin-horizontally" *ngIf="loanService.errorState$ | async">
            <h4 class="grid-spacing-small">
                {{ 'loan.error_message____header' | translate }}
            </h4>
            <p class="grid-spacing-small">
                {{ 'loan.error_message____text' | translate }}
            </p>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoanErrorComponent {
    constructor(public loanService: LoanService) {}
}
